import { createFileRoute } from '@tanstack/react-router';
import { UsersPage } from '../../../usuarios/users-page.tsx';

export const Route = createFileRoute('/usuarios/')({
  component: UsersPage,
});
